module.exports = __webpack_public_path__ + "static/img/tbTsb.274e0ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/tbTsb.jpg
// module id = VQ+2
// module chunks = 4